'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _immutable = require('immutable');

var _WMPaper = require('@workmarket/front-end-components/dist/WMPaper');

var _WMPaper2 = _interopRequireDefault(_WMPaper);

var _WMHeading = require('@workmarket/front-end-components/dist/WMHeading');

var _WMHeading2 = _interopRequireDefault(_WMHeading);

var _WMTable = require('@workmarket/front-end-components/dist/WMTable');

var _WMTable2 = _interopRequireDefault(_WMTable);

var _WMTableBody = require('@workmarket/front-end-components/dist/WMTableBody');

var _WMTableBody2 = _interopRequireDefault(_WMTableBody);

var _WMTableRow = require('@workmarket/front-end-components/dist/WMTableRow');

var _WMTableRow2 = _interopRequireDefault(_WMTableRow);

var _WMTableCell = require('@workmarket/front-end-components/dist/WMTableCell');

var _WMTableCell2 = _interopRequireDefault(_WMTableCell);

var _WMTableHeader = require('@workmarket/front-end-components/dist/WMTableHeader');

var _WMTableHeader2 = _interopRequireDefault(_WMTableHeader);

var _WMTableHeaderCell = require('@workmarket/front-end-components/dist/WMTableHeaderCell');

var _WMTableHeaderCell2 = _interopRequireDefault(_WMTableHeaderCell);

var _WMRaisedButton = require('@workmarket/front-end-components/dist/WMRaisedButton');

var _WMRaisedButton2 = _interopRequireDefault(_WMRaisedButton);

var _WMStat = require('../WMStat');

var _WMStat2 = _interopRequireDefault(_WMStat);

var _styles = require('./styles');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getComponentIdentifier = function getComponentIdentifier(id) {
	return 'wm-company-page__talent-pools__' + id;
};
var truncatePoolDescription = function truncatePoolDescription(rawDescription) {
	return rawDescription.slice(0, 200) + '...';
};

var WMCompanyPagesTalentPools = function WMCompanyPagesTalentPools(_ref) {
	var talentPools = _ref.talentPools,
	    name = _ref.name,
	    satisfactionRate = _ref.satisfactionRate,
	    avgTimeToPayWorkInDays = _ref.avgTimeToPayWorkInDays,
	    avgTimeToApproveWorkInDays = _ref.avgTimeToApproveWorkInDays;

	var paymentTimelinessLabel = void 0;
	if (avgTimeToPayWorkInDays < 0) {
		paymentTimelinessLabel = 'Early';
	} else if (avgTimeToPayWorkInDays >= 0 && avgTimeToPayWorkInDays < 1) {
		paymentTimelinessLabel = 'On Time';
	} else {
		paymentTimelinessLabel = 'Late';
	}
	var tableBody = talentPools.map(function (pool) {
		return _react2.default.createElement(
			_WMTableRow2.default,
			{
				key: pool.get('id')
			},
			_react2.default.createElement(
				_WMTableCell2.default,
				{
					style: _styles2.default.poolName
				},
				pool.get('name')
			),
			_react2.default.createElement(
				_WMTableCell2.default,
				{
					style: _styles2.default.tableBodyText
				},
				pool.get('description').length > 200 ? truncatePoolDescription(pool.get('description')) : pool.get('description')
			),
			_react2.default.createElement(
				_WMTableCell2.default,
				{
					style: _styles2.default.tableBodyText
				},
				pool.get('requirementsMet') + ' of ' + pool.get('requirements')
			),
			_react2.default.createElement(
				_WMTableCell2.default,
				null,
				_react2.default.createElement(_WMRaisedButton2.default, {
					label: 'JOIN',
					href: '/groups/' + pool.get('id'),
					secondary: true
				})
			)
		);
	});
	return _react2.default.createElement(
		_WMPaper2.default,
		{
			rounded: false,
			style: _styles2.default.container,
			zDepth: 2
		},
		_react2.default.createElement(
			'div',
			{
				style: _styles2.default.inner
			},
			_react2.default.createElement(
				_WMHeading2.default,
				{
					level: '3',
					style: _styles2.default.header
				},
				'Work for ' + name
			),
			_react2.default.createElement(
				'div',
				{
					style: _styles2.default.statsContainer,
					'data-attr-id': 'wm-company-page__stats-container'
				},
				_react2.default.createElement(_WMStat2.default, {
					title: satisfactionRate + '%',
					subtitle: 'Satisfaction'
				}),
				_react2.default.createElement(_WMStat2.default, {
					title: paymentTimelinessLabel,
					subtitle: 'Payment Timeliness'
				}),
				_react2.default.createElement(_WMStat2.default, {
					title: avgTimeToApproveWorkInDays + ' days',
					subtitle: 'Approval Time'
				})
			)
		),
		talentPools.size > 0 && _react2.default.createElement(
			'div',
			null,
			_react2.default.createElement(
				_WMHeading2.default,
				{
					style: _styles2.default.inner,
					level: '4'
				},
				'Join our Labor Clouds to be notified when new work becomes available.'
			),
			_react2.default.createElement(
				_WMTable2.default,
				{
					hideDisabledCheckboxes: true,
					striped: true
				},
				_react2.default.createElement(
					_WMTableHeader2.default,
					null,
					_react2.default.createElement(
						_WMTableHeaderCell2.default,
						{
							'data-attr-id': getComponentIdentifier('name-header-cell')
						},
						'Labor Cloud'
					),
					_react2.default.createElement(
						_WMTableHeaderCell2.default,
						{
							'data-attr-id': getComponentIdentifier('description-header-cell')
						},
						'Description'
					),
					_react2.default.createElement(
						_WMTableHeaderCell2.default,
						{
							'data-attr-id': getComponentIdentifier('requirements-header-cell')
						},
						'Requirements You Meet'
					),
					_react2.default.createElement(
						_WMTableHeaderCell2.default,
						{
							'data-attr-id': getComponentIdentifier('apply-header-cell')
						},
						''
					)
				),
				_react2.default.createElement(
					_WMTableBody2.default,
					null,
					tableBody.toJS()
				)
			)
		)
	);
};

var _default = WMCompanyPagesTalentPools;
exports.default = _default;


WMCompanyPagesTalentPools.propTypes = {
	name: _propTypes.PropTypes.string.isRequired,
	talentPools: _propTypes.PropTypes.instanceOf(_immutable.List),
	satisfactionRate: _propTypes.PropTypes.number.isRequired,
	avgTimeToPayWorkInDays: _propTypes.PropTypes.number.isRequired,
	avgTimeToApproveWorkInDays: _propTypes.PropTypes.number.isRequired
};

WMCompanyPagesTalentPools.defaultProps = {
	talentPools: []
};
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}

	__REACT_HOT_LOADER__.register(getComponentIdentifier, 'getComponentIdentifier', 'src/components/WMCompanyPageTalentPools/template.js');

	__REACT_HOT_LOADER__.register(truncatePoolDescription, 'truncatePoolDescription', 'src/components/WMCompanyPageTalentPools/template.js');

	__REACT_HOT_LOADER__.register(WMCompanyPagesTalentPools, 'WMCompanyPagesTalentPools', 'src/components/WMCompanyPageTalentPools/template.js');

	__REACT_HOT_LOADER__.register(_default, 'default', 'src/components/WMCompanyPageTalentPools/template.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/@workmarket/wm-company-pages-spa/build/components/WMCompanyPageTalentPools/template.js
// module id = ifzK
// module chunks = 62 63